/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import logo from '../../assets/img/mealtrist-logo.png';
import { Link, Redirect } from 'react-router-dom';
import MainHeader from '../header';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';
import MainFooter from '../../components/Core/footer';

class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {email: "", message: "", loading: "false", confirmationMessage: "", name: "", confirmationPhone: this.props.confirmationPhone, redirecting: "", provider: "cox", leadSource: "500", tfn: "772-452-4565", text: "The TransactionID is "};
        this.handleEmail = this.handleEmail.bind(this);
        this.handleName = this.handleName.bind(this);
        this.handleMessage = this.handleMessage.bind(this);
        this.submit = this.submit.bind(this);
        this.callContact = this.callContact.bind(this);
    }

    handleMessage(e) {
        this.setState({message: e.target.value});
    }

    handleName(e) {
        this.setState({name: e.target.value});
    }

    handleEmail(e) {
        this.setState({email: e.target.value});
    }

    submit(e) {
        const globalThis = this;
        const customer = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber
        };
        globalThis.setState(prevState => ({
            loading: "true"
        }));

    }

    callContact() {
        const globalThis = this;
        console.log(this.state.loading);
        if (this.state.loading === "true") {
            $.ajax({
                url: process.env.REACT_APP_API_HOST + '/' + 'api/contact',
                type: 'post',
                async: false,
                data: {
                    email: this.state.email,
                    name: this.state.name,
                    message: this.state.message
                },
                error: function (response) {
                    //Failed response
                    // logOrderError(visitID, 'otsError', completeOrderData, response);
                },
                success: function (response) {
                    console.log(response);
                    globalThis.setState(prevState => ({
                        loading: "false"
                    }));
                    globalThis.setState({confirmationMessage: "Your message has been sent. Thank you for your interest in our web team we will connect back with you shortly."});
                }
            });
        }
    }

    componentDidMount() {
        // if(this.state.provider != "") {
        //     require('../assets/css/' + this.state.provider + '.css');
        // }
    }

    componentDidUpdate() {
        console.log("loading");
        console.log(this.state.loading);
        const globalThis = this;
        if(this.state.loading === "true") {
            console.log("in did mount");
            setTimeout(function(){ globalThis.callContact(); }, 1000);
        }
    }

    //TODO set referrer url link in containers first child link
    render() {
        console.log(this.state.loading);
        let output =
            <div>
                <MainHeader/>
                <div className="container-fluid main-body-content">

                    {this.state.confirmationMessage !== "" &&
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="panel panel-default">
                                <div className="panel-heading text-center"><h3>{this.state.confirmationMessage}</h3></div>
                            </div>
                        </div>
                    </div>
                    }
                    { (this.state.loading === "false" && this.state.confirmationMessage === "") &&
                        <div className="panel panel-default">
                            <div className="panel-heading text-center"><h3>Contact Form</h3></div>

                            <div className="panel-body">
                                <ReactBootstrap.Form horizontal action="http://www.mealtrist.com/login">
                                    <div className="info1-widget">
                                        <div className="info-top clearfix">
                                            {/*<!--<h3 className="pull-left"><span>3</span> Enter Customer's Information</h3>-->*/}
                                            {/*<h3 className="text-center margin-bottom-2-half"></h3>*/}
                                        </div>
                                        <div className="inner clearfix">
                                            <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                                <div className="row">
                                                    <ReactBootstrap.Col lg={3}>
                                                    </ReactBootstrap.Col>
                                                    <ReactBootstrap.Col lg={6}>
                                                        <ReactBootstrap.FormControl type="email"
                                                                                    onChange={this.handleEmail}
                                                                                    placeholder="Email"/>
                                                    </ReactBootstrap.Col>
                                                </div>
                                            </ReactBootstrap.FormGroup>
                                            <ReactBootstrap.FormGroup bsSize="large" controlId="formGroupPassword">
                                                <div className="row">
                                                    <ReactBootstrap.Col lg={3}>
                                                    </ReactBootstrap.Col>
                                                    <ReactBootstrap.Col lg={6}>
                                                        <ReactBootstrap.FormControl type="name"
                                                                                    onChange={this.handleName}
                                                                                    placeholder="Name"/>
                                                    </ReactBootstrap.Col>
                                                </div>
                                            </ReactBootstrap.FormGroup>
                                            <ReactBootstrap.FormGroup bsSize="large" controlId="formControlsMessage">
                                                <div className="row">
                                                    <ReactBootstrap.Col lg={3}>
                                                    </ReactBootstrap.Col>
                                                    <ReactBootstrap.Col lg={6}>
                                                        <ReactBootstrap.FormControl type="message"
                                                                                    componentClass="textarea"
                                                                                    onChange={this.handleMessage}
                                                                                    placeholder="Reason for Connecting..."/>
                                                    </ReactBootstrap.Col>
                                                </div>
                                            </ReactBootstrap.FormGroup>
                                            <ReactBootstrap.FormGroup bsSize="large" controlId="formGroupLogin">
                                                <div className="row">
                                                    <ReactBootstrap.Col lg={3}>
                                                    </ReactBootstrap.Col>
                                                    <ReactBootstrap.Col lg={6}>
                                                        <ReactBootstrap.Button bsStyle="primary" onClick={this.submit}
                                                                               bsSize="large"
                                                                               block>Submit</ReactBootstrap.Button>
                                                    </ReactBootstrap.Col>
                                                </div>
                                            </ReactBootstrap.FormGroup>
                                        </div>
                                    </div>
                                </ReactBootstrap.Form>
                            </div>
                        </div>
                    }
                    { this.state.loading === "true" &&
                    <div>
                        <div className="text-center main-body-content">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"> </i>
                        </div>
                    </div>
                    }
                </div>
                <MainFooter/>
            </div>

        if(this.state.redirecting !== "") {
            output = this.state.redirecting;
        }
        return (
            output
        );
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Pages/contact.js